import { useQuery } from '@apollo/client';
import {
  PendingPrescriptionsQueryResponse,
  pendingPrescriptions,
} from '@queries/order/queries/pendingPrescriptions';
import { UploadImage } from '@components/prescriptions/UploadImage';
import { BorderedContainer } from '@screens/checkout/components/BorderedContainer';
import { UploadImageContainer } from './PendingPrescriptions.styles';

interface PendingPrescriptionsProps {
  hasInsurance: boolean;
  error: boolean;
  setError: (boolean) => void;
}
export function PendingPrescriptions({
  hasInsurance,
  error,
  setError,
}: PendingPrescriptionsProps) {
  const { data: prescriptionsData } =
    useQuery<PendingPrescriptionsQueryResponse>(pendingPrescriptions(), {
      fetchPolicy: 'cache-and-network',
    });

  return (
    <BorderedContainer title="Recetas">
      <UploadImageContainer>
        <UploadImage
          hasInsurance={hasInsurance}
          confirmText
          emptyImagesError={error}
          setEmptyImagesError={setError}
          pendingPrescriptions={prescriptionsData?.pendingPrescriptions}
        />
      </UploadImageContainer>
    </BorderedContainer>
  );
}
